<div fxLayout="row" gdColumns="10%" style="margin:10px">
  <kendo-label text="Store ">
    <kendo-dropdownlist
      [data]="storeList"
      textField="display"
      valueField="storeID"
      [(ngModel)]="selectedStore"
      (valueChange)="storeValueChange($event)"
      style="width: 199px; height: 30px">
    </kendo-dropdownlist>
  </kendo-label>
</div>

<div fxLayout="row" gdColumns="50% 50%" style="margin:5px">


  <div fxLayout="column" fxlayout.sm="column" fxlayout.xs="column" gdColumns="100%"
       style="flex-direction: row; box-sizing: border-box; display: flex; flex: 0 0  auto;">


    <div class="card">
      <div>
        <kendo-floatinglabel text="Store Name">
          <input [disabled]="true" [(ngModel)]="storeName" name="storeName" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Primary DC">
          <input [disabled]="true" [(ngModel)]="primaryDC" name="primaryDC" kendoTextBox/>
        </kendo-floatinglabel>
      </div>
      <div>
        <kendo-floatinglabel text="City">
          <input [disabled]="true" [(ngModel)]="city" name="city" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Chain">
          <input [disabled]="true" [(ngModel)]="chain" name="chain" kendoTextBox/>
        </kendo-floatinglabel>
      </div>

      <div>
        <kendo-floatinglabel text="Address">
          <input [disabled]="true" [(ngModel)]="address" name="address" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Data Line">
          <input [disabled]="true" [(ngModel)]="dataLine" name="dataLine" kendoTextBox/>
        </kendo-floatinglabel>
      </div>

      <div>
        <kendo-floatinglabel [style.width]="'50px'" floatingLabel="State">
          <input [disabled]="true" [(ngModel)]="state" name="state" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel [style.width]="'129px'" floatingLabel="Zip">
          <input [disabled]="true" [(ngModel)]="zip" name="zip" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Voice Line" placeholder="Voice Line">
          <input [disabled]="true" [(ngModel)]="voiceLine" name="voiceLine" kendoTextBox/>
        </kendo-floatinglabel>
      </div>

      <div style="padding-top: 10px">

        <input type="checkbox" [disabled]="false" [(ngModel)]="apExportSum" kendoCheckBox
               name="summarizeInvoiceExport"/>
        <label class="k-label"> Summarize Invoice Export</label>


      </div>

    </div>


    <div class="card"> <!--    style=" max-width: 50%;"-->
      <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start none" style="margin-bottom: 4px">
        <!--      <div>-->
        <!--        <input type="checkbox" [disabled]="false" kendoCheckBox name="exportSegment"/>-->
        <!--        <label class="k-label"> Export with Segment Separator</label>-->
        <!--      </div>-->


        <kendo-grid
          [kendoGridBinding]="gridDataSegments"
          [kendoGridSelectBy]="selectedCallbackSegments"
          [(selectedKeys)]="mySelectionSegments"
          [selectable]="{checkboxOnly: false, mode: 'multiple'}"
          [scrollable]="true"
          [height]="250">
          <kendo-grid-checkbox-column [width]="55"></kendo-grid-checkbox-column>
          <kendo-grid-column field="length" title="Segments" [width]="200"></kendo-grid-column>
        </kendo-grid>


        <div fxLayout="row" fxLayoutAlign=" center">
          <app-mcl-button text="Add Segment" primary="true" (click)="addSegment()">
          </app-mcl-button>
          &nbsp;&nbsp;
          <app-mcl-button text="Delete Segment" primary="true" (click)="deleteSegment()">
          </app-mcl-button>
        </div>
      </div>

    </div>


  </div>


  <div fxLayout="column" fxlayout.sm="column" fxlayout.xs="column" gdColumns="100%"
       style="flex-direction: row; box-sizing: border-box; display: flex; flex: 0 0  auto;">
    <!--  <div fxLayout="row" fxLayoutGap="10px" gdColumns="15% 15% " fxLayoutAlign=" start none"-->
    <!--       style="margin-bottom: 4px">-->


    <!--    <div class="card" fxflex="" style="flex: 1 1 0%; box-sizing: border-box;">-->


    <div class="card">
      <div>
        <kendo-floatinglabel text="Default GL Code">
          <input [disabled]="false" [(ngModel)]="defaultGL" name="defaultGL" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Discount GL Code">
          <input [disabled]="false" [(ngModel)]="discountGL" name="discountGL" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Surcharge GL">
          <input [disabled]="false" [(ngModel)]="surchargeGL" name="surchargeGL" kendoTextBox/>
        </kendo-floatinglabel>
      </div>

      <div>
        <kendo-floatinglabel text="Sales Tax GL Code">
          <input [disabled]="false" [(ngModel)]="salesTaxGL" name="salesTaxGL" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="A/P Account">
          <input [disabled]="false" [(ngModel)]="apAccount" name="apAccount" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Division">
          <input [disabled]="false" [(ngModel)]="division" name="division" kendoTextBox/>
        </kendo-floatinglabel>
      </div>

      <div>
        <kendo-floatinglabel text="Site">
          <input [disabled]="false" [(ngModel)]="site" name="site" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Food Vendor">
          <input [disabled]="false" [(ngModel)]="foodVendor" name="foodVendor" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Equipment Vendor">
          <input [disabled]="false" [(ngModel)]="equipmentVendor" name="equipmentVendor" kendoTextBox/>
        </kendo-floatinglabel>
      </div>

      <div>
        <kendo-floatinglabel text="Segment Separator">
          <input [disabled]="false" [(ngModel)]="segmentSeparator" name="segmentSeparator" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Department Number">
          <input [disabled]="false" [(ngModel)]="departmentNumber" name="departmentNumber" kendoTextBox/>
        </kendo-floatinglabel>
        &nbsp;&nbsp;
        <kendo-floatinglabel text="Location Number">
          <input [disabled]="false" [(ngModel)]="locationNumber" name="locationNumber" kendoTextBox/>
        </kendo-floatinglabel>
      </div>

      <div style="padding-top: 10px">

        <input type="checkbox" [disabled]="false"  [(ngModel)]="exportWithSaparator" kendoCheckBox name="exportSegment"/>
        <label class="k-label"> Export with Segment Separator</label>




      </div>

    </div>


    <div class="card"> <!--    style=" max-width: 50%;"-->
      <div fxLayout="column" fxLayoutGap="15px" fxLayoutAlign=" none">
        <!--      <div>-->
        <!--        <input type="checkbox" [disabled]="false" [(ngModel)]="apExportSum" kendoCheckBox-->
        <!--               name="summarizeInvoiceExport"/>-->
        <!--        <label class="k-label"> Summarize Invoice Export</label>-->
        <!--      </div>-->


        <div style="margin-bottom: 15px">
          <kendo-label text="Package Name ">
            <kendo-dropdownlist
              [data]="packageNameList"
              [defaultItem]="placeHolder"
              [(ngModel)]="selectedPackageName"
              (valueChange)="packageNameValueChange($event)"
              textField="pkg"
              valueField="pkg"
              style = "width: 170px; height: 30px">
            </kendo-dropdownlist>
          </kendo-label>
        </div>

        <kendo-grid
          [kendoGridBinding]="gridDataFileNames"
          [kendoGridSelectBy]="selectedCallbackFileNames"
          [selectedKeys]="mySelectionFileNames"
          [selectable]="{enabled: true, checkboxOnly: true, mode: 'multiple'}"
          [scrollable]="true"
          [height]="200">
          <kendo-grid-checkbox-column [width]="55">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <input type="checkbox" kendoCheckBox [(ngModel)]="dataItem.assigned" (change)="setChanges(dataItem)"/>
              <!--            <input [kendoGridSelectionCheckbox]="dataItem.assigned"/>-->
            </ng-template>
          </kendo-grid-checkbox-column>
          <kendo-grid-column field="fileName" title="File Names" [width]="200"></kendo-grid-column>
        </kendo-grid>

        <div fxLayout="row" fxLayoutAlign="end center">
          <app-mcl-button text="Save" primary="true" (click)="save()">
          </app-mcl-button>
        </div>
      </div>

    </div>


  </div>


</div>

<div kendoDialogContainer></div>
